import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  user: {
    name: "",
    email: "",
    role: "",
    udise_id: "",
  },
  lang: 'en-IN',
  // false until the boot loadUser (/me) call settles. Route guards WAIT on this
  // instead of bouncing to "/" while auth is still being restored on a full page
  // load / refresh / new tab (there is no redux-persist, so user.role starts empty).
  authChecked: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userRegistration: (state, action) => {
      state.token = action.payload.token;
    },
    userLoggedIn: (state, action) => {
      console.log("user is logged in", action.payload);
      console.log('🔍 [DEBUG] Redux storing user.school_type:', action.payload.user?.school_type);
      state.token = action.payload.accessToken;
      state.user = action.payload.user;
      state.lang = action.payload.lang;
      state.authChecked = true;
    },
    userLoggedOut: (state) => {
      state.token = "";
      state.user = "";
      state.lang = 'en-IN';
      state.authChecked = true;
    },
    changeLang: (state, action) => {
      state.lang = action.payload
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    }
  },
});

export const { userRegistration, userLoggedIn, userLoggedOut, changeLang, updateUser } =
  authSlice.actions;

export default authSlice.reducer;